export const CONVERSATION_SERVICE_TIMEOUT_MS = 9500;
export const POLLING_INTERVAL_MS = 45000;

/** Shared action types */
export const SET_UNREAD_MESSAGES_COUNT = 'SET_UNREAD_MESSAGES_COUNT';
